import { LiteYouTube } from "@/components/LiteYouTube";

export function GalleryCarousel({ videos, photos, onFullscreen }) {  if (!videos.length && !photos.length) {
    return (
      <div className="bg-white rounded-2xl border border-stone-200/60 p-6 text-center text-stone-400 text-sm shadow-sm">
        Belum ada foto / video kegiatan.
      </div>
    );
  }
  return (
    <div data-testid="home-gallery-carousel" className="space-y-4">
      {photos.length > 0 && (
        <div>
          <p className="text-sm font-heading font-bold text-stone-700 mb-2" data-testid="home-foto-title">Foto Dokumentasi Kegiatan Sekolah</p>
          <div className="flex overflow-x-auto gap-3 pb-1 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: "none" }}>
            {photos.map((s, i) => (
              <button key={i} data-testid={`carousel-photo-${i}`} onClick={() => onFullscreen(i)}
                className="shrink-0 w-40 h-40 rounded-2xl overflow-hidden bg-stone-100 shadow-sm active:scale-[0.98] transition-transform">
                <img src={s.thumb || s.url} alt="kegiatan" loading="lazy" className="w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.style.display = "none"; }} />
              </button>
            ))}
          </div>
        </div>
      )}
      {videos.length > 0 && (
        <div>
          <p className="text-sm font-heading font-bold text-stone-700 mb-2" data-testid="home-video-title">Video Dokumentasi Kegiatan Sekolah</p>
          <div className="flex overflow-x-auto gap-3 pb-1 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: "none" }}>
            {videos.map((s, i) => (
              <div key={i} data-testid={`carousel-video-${i}`} className="shrink-0 w-72 rounded-2xl overflow-hidden border border-stone-200/60 shadow-sm bg-white">
                <div className="aspect-video bg-black">
                  <LiteYouTube id={s.youtube_id} title={s.title} />
                </div>
                <p className="px-3 py-2 text-sm font-semibold text-stone-700 truncate">{s.title}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
